export const LOAD_MEMBERSHIPS = "metabase/admin/people/LOAD_MEMBERSHIPS";
export const CREATE_MEMBERSHIP = "metabase/admin/people/CREATE_MEMBERSHIP";
export const DELETE_MEMBERSHIP = "metabase/admin/people/DELETE_MEMBERSHIP";
export const CLEAR_TEMPORARY_PASSWORD =
  "metabase/admin/people/CLEAR_TEMPORARY_PASSWORD";
